import axios from 'axios'
import { useUserStore } from '@/stores/UserStore'
import { postLog } from '@/api/postLog'

export async function useAuthUser (phone, code) {
  const userStore = useUserStore()
  const { setUserToken, setUser } = userStore

  try {
    const deviceUUID = window?.device?.uuid
      ? new URLSearchParams({
        device_uuid: window?.device?.uuid
      }).toString()
      : ''

    const response = await axios.get('/v1/auth/login?' + deviceUUID, {
      headers: {
        Authorization: `Basic ${btoa(phone + ':' + code)}`,
        'Cache-Control': 'no-cache'
      }
    })
    if (response.data.status === 'ok') {
      setUserToken(response.data.data.token)
      await setUser(response.data.data.token)
      return response
    }
  } catch (err) {
    postLog({
      m: 'useAuthUser ERROR',
      err: err
    })
    throw new Error(err)
  }
}
